"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _buttonview = _interopRequireDefault(require("@ckeditor/ckeditor5-ui/src/button/buttonview"));
var _plugin = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/plugin"));
var _clickobserver = _interopRequireDefault(require("@ckeditor/ckeditor5-engine/src/view/observer/clickobserver"));
// 这个模块是用来监听 click的

// 按钮的图标 SVG
var uploadAttachmentIcon = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n  viewBox=\"0 0 200 200\" style=\"enable-background:new 0 0 200 200;\" xml:space=\"preserve\">\n<path class=\"st0\" d=\"M92.4,69.4l-38.2,38.2c-13.2,13.2-13.2,34.6,0,47.8c13.2,13.2,34.6,13.2,47.8,0l47.8-47.8\n c2.6-2.6,6.9-2.6,9.6,0c2.6,2.6,2.6,6.9,0,9.6L111.5,165c-18.5,18.5-48.4,18.4-66.9,0c-18.5-18.5-18.5-48.4,0-66.9l66.9-66.9\n c0,0,0,0,0,0c13.2-13.2,34.5-13.2,47.8,0c13.2,13.2,13.3,34.5,0,47.8l-38.3,38.3l-28.6,28.6c-7.9,7.9-20.8,8-28.7,0\n c-7.9-7.9-8-20.7,0-28.7l66.9-66.9c2.6-2.6,6.9-2.6,9.6,0c2.6,2.6,2.6,6.9,0,9.6l-66.9,66.9c-2.7,2.7-2.7,6.9,0,9.6\n c2.7,2.7,6.9,2.6,9.6,0l28.6-28.6l38.3-38.3c8-8,7.9-20.7,0-28.7c-7.9-7.9-20.7-8-28.6-0.1c0,0-0.1,0.1-0.1,0.1L92.4,69.4L92.4,69.4\n z\"/>\n</svg>\n";
var BoxUI = exports.default = /*#__PURE__*/function (_Plugin) {
  function BoxUI() {
    (0, _classCallCheck2.default)(this, BoxUI);
    return (0, _callSuper2.default)(this, BoxUI, arguments);
  }
  (0, _inherits2.default)(BoxUI, _Plugin);
  return (0, _createClass2.default)(BoxUI, [{
    key: "init",
    value: function init() {
      this._defineBtnView();
    }

    // toolbar btn
  }, {
    key: "_defineBtnView",
    value: function _defineBtnView() {
      var _this = this;
      // 获取当前编辑器
      var editor = this.editor;
      // 从当前编辑器的配置中获取传入的自定义配置名称
      var uploadAttachment = this.editor.config.get('uploadAttachment');

      // 将自定义按钮添加到当前编辑器的组件工厂
      editor.ui.componentFactory.add('uploadAttachment', function (locale) {
        var view = editor.editing.view;
        var command = editor.commands.get('uploadAttachment');

        // 使用模块
        view.addObserver(_clickobserver.default);

        // 获取当前编辑器的按钮视图
        var buttonView = new _buttonview.default(locale);

        // 在按钮视图中注入自定义按钮的名称、图标
        buttonView.set({
          label: '附件',
          icon: uploadAttachmentIcon,
          // 开启提示，当鼠标悬浮到按钮上，会显示 label 指定的 uploadAttachment 字样
          tooltip: true
        });

        // 将按钮的状态绑定到命令。
        buttonView.bind('isOn', 'isEnabled').to(command, 'value', 'isEnabled');
        // 单击(执行)按钮时执行命令。
        _this.listenTo(buttonView, 'execute', function () {
          editor.execute('uploadAttachment');
          // 执行自定义配置中指定的回调函数
          uploadAttachment.handler.call();
        });

        // 返回修改后的视图内容
        // return view
        return buttonView;
      });
    }
  }]);
}(_plugin.default);